var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAtvi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-76170688-0681-420d-8af4-a510f8ddcb1d",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-fe03add0-6959-4089-9960-691293bf149b{fill:#fff;fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 513,
    height: 513
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-c7308c43-c016-45ee-9cc4-e8ed63c2c728",
    className: "uuid-fe03add0-6959-4089-9960-691293bf149b",
    d: "m256,115.48l98.08,281.04h-53.57l-13.27-35.77h-62.47l-13.29,35.77h-53.57L256,115.48Zm13.75,194.03l-14.84-49.06-14.83,49.06h29.67Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtvi);
export default __webpack_public_path__ + "static/media/icon_atvi.5a8dff0cd0125577e3f9de40d1a0e278.svg";
export { ForwardRef as ReactComponent };